// This is the master data of the keuze wijzer. It describes which choices lead to which company types.

import { ResultBvPage, ResultCommvPage, ResultEmzPage, ResultVofPage } from "../../pages/keuzewijzerpages"
import { ActivityDuration, AmountOfDirectors, CompanyType, EstimatedResult, PrivateAssets, TypeOfActivity } from "./keuzewijzerenums"
import { KeuzeWijzerState } from "./keuzewijzerstate"
import { ResultValueAndPage } from "../statemachine/resultvalueandpage"

const bv: Array<KeuzeWijzerState> = [
    new KeuzeWijzerState({ amountOfDirectors: AmountOfDirectors.Single, typeOfActivity: TypeOfActivity.Main, estimatedResult: EstimatedResult.MoreThan20k }),
    new KeuzeWijzerState({ amountOfDirectors: AmountOfDirectors.Single, typeOfActivity: TypeOfActivity.Secondary, privateAssets: PrivateAssets.Protected }),
    new KeuzeWijzerState({ amountOfDirectors: AmountOfDirectors.Single, typeOfActivity: TypeOfActivity.Secondary, privateAssets: PrivateAssets.Unprotected, partnerHasShares: false, activityDuration: ActivityDuration.MoreThan3Years }),
    new KeuzeWijzerState({ amountOfDirectors: AmountOfDirectors.Multiple, privateAssets: PrivateAssets.Protected })
]

const commv: Array<KeuzeWijzerState> = [
    new KeuzeWijzerState({ amountOfDirectors: AmountOfDirectors.Single, typeOfActivity: TypeOfActivity.Secondary, privateAssets: PrivateAssets.Unprotected, partnerHasShares: true }),
    new KeuzeWijzerState({ amountOfDirectors: AmountOfDirectors.Multiple, privateAssets: PrivateAssets.Unprotected, eachDirectorHasDecisionMaking: false })
]

const vof: Array<KeuzeWijzerState> = [
    new KeuzeWijzerState({ amountOfDirectors: AmountOfDirectors.Multiple, privateAssets: PrivateAssets.Unprotected, eachDirectorHasDecisionMaking: true })
]

const emz: Array<KeuzeWijzerState> = [
    new KeuzeWijzerState({ amountOfDirectors: AmountOfDirectors.Single, typeOfActivity: TypeOfActivity.Main, estimatedResult: EstimatedResult.LessThan20k }),
    new KeuzeWijzerState({ amountOfDirectors: AmountOfDirectors.Single, typeOfActivity: TypeOfActivity.Secondary, privateAssets: PrivateAssets.Unprotected, partnerHasShares: false, activityDuration: ActivityDuration.LessThan3Years })
]

export const masterData = new Map<ResultValueAndPage<CompanyType>, Array<KeuzeWijzerState>>([
    [new ResultValueAndPage<CompanyType>(ResultBvPage, CompanyType.Bv), bv],
    [new ResultValueAndPage<CompanyType>(ResultCommvPage, CompanyType.Commv), commv],
    [new ResultValueAndPage<CompanyType>(ResultVofPage, CompanyType.Vof), vof],
    [new ResultValueAndPage<CompanyType>(ResultEmzPage, CompanyType.Emz), emz]
])
